import { render, staticRenderFns } from "./EventOrganizer.vue?vue&type=template&id=633f3e68&scoped=true"
import script from "./EventOrganizer.vue?vue&type=script&lang=js"
export * from "./EventOrganizer.vue?vue&type=script&lang=js"
import style0 from "./EventOrganizer.vue?vue&type=style&index=0&id=633f3e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f3e68",
  null
  
)

export default component.exports